import { RunState } from "types/generated";
import Box from "ds/components/Box";
import RunPhaseLogs from "components/Run/elements/RunPhaseLogs";
import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";

import { RunHistoryEntryType } from "../../types";
import { useVisibilityToggle } from "../../hooks/useVisibilityToggle";

type PreparingEntryProps = {
  timestamp: number;
  until: number | null;
  state: RunState;
  stateVersion: number | null;
  hasLogs: boolean;
  openLogsByDefault: boolean;
  runId: string;
  stackId: string;
  isModuleRun: boolean;
};

const PreparingEntry = ({
  timestamp,
  until,
  state,
  stateVersion,
  hasLogs,
  openLogsByDefault,
  runId,
  stackId,
  isModuleRun,
}: PreparingEntryProps) => {
  const [showLogs, toggleLogs] = useVisibilityToggle(openLogsByDefault, hasLogs);

  return (
    <HistoryEntryWrapper
      state={RunHistoryEntryType.Preparing}
      timestamp={timestamp}
      until={until}
      isLoading={!until}
      onClick={toggleLogs}
      isOpen={showLogs}
    >
      {showLogs && (
        <Box direction="column" align="start" gap="medium" padding="0 0 0 small" fullWidth>
          <RunPhaseLogs
            state={state}
            stateVersion={stateVersion}
            until={until}
            runId={runId}
            stackId={stackId}
            isModuleRun={isModuleRun}
          />
        </Box>
      )}
    </HistoryEntryWrapper>
  );
};

export default PreparingEntry;
